import React, {useRef,useState} from 'react';
import { consultancySteps } from '../../mock';
import {useForms} from '../../context/FormsContext';
import useReveal from '../../hooks/useReveal';

export default function ConsultancyFlow() {
  useReveal();
  const [active,setActive]=useState(null);
  const buttons=useRef({});
  const {openForm}=useForms();
  const close=()=>{setActive(null);buttons.current[active]?.focus();};
  const goToAnalysis=event=>{
    event.preventDefault();
    openForm(undefined,'danismanlik-ihtiyac-analizi');
    document.querySelector('#analiz button')?.focus({preventScroll:true});
  };
  return (
    <section id="danismanlik" className="ckr-section" style={{ background: 'transparent' }} onKeyDown={event=>{if(event.key==='Escape'&&active){event.preventDefault();close();}}}>
      <div className="ckr-container">
        <div className="ckr-fade-up" style={{ maxWidth: 640, marginBottom: 44 }}>
          <span className="ckr-eyebrow">Danışmanlık Akışı</span>
          <h2 style={{ fontSize: 'clamp(25px, 2.8vw, 34px)', fontWeight: 600, color: '#f3efe6', marginTop: 12, marginBottom: 14 }}>
            Ezberle değil, net bir süreçle ilerliyoruz
          </h2>
          <p style={{ fontSize: 17, color: 'rgba(233,235,228,0.72)', margin: 0 }}>
            Dört adımda; ihtiyacınızdan piyasa gerçeklerine, oradan sağlam bir karara.
          </p>
        </div>
        <div className="ckr-fade-up ckr-flow-grid">
          {consultancySteps.map(step=><article key={step.no} className={`ckr-card ckr-flow-card${active===step.no?' is-open':''}`}>
            <span className="ckr-flow-number">{step.no}</span>
            <h3><button ref={node=>{buttons.current[step.no]=node;}} type="button" id={`ckr-flow-toggle-${step.no}`} className="ckr-flow-toggle" aria-expanded={active===step.no} aria-controls={`ckr-flow-panel-${step.no}`} aria-label={`${step.title} — Nasıl çalışıyoruz?`} onClick={()=>setActive(current=>current===step.no?null:step.no)}>{step.title}</button></h3>
            <p className="ckr-flow-headline">{step.headline}</p>
            <p className="ckr-flow-description">{step.desc}</p>
            <span className="ckr-flow-link" aria-hidden="true">Nasıl çalışıyoruz?</span>
          </article>)}
        </div>
        <div className="ckr-flow-details">
          {consultancySteps.map(step=><section key={step.no} id={`ckr-flow-panel-${step.no}`} role="region" aria-labelledby={`ckr-flow-panel-title-${step.no}`} aria-hidden={active!==step.no} inert={active!==step.no?true:undefined} className={`ckr-flow-panel${active===step.no?' is-open':''}`}>
            <div className="ckr-flow-panel-inner"><div className="ckr-flow-panel-body">
              <div className="ckr-flow-panel-heading"><span className="ckr-flow-number">{step.no}</span><h3 id={`ckr-flow-panel-title-${step.no}`}>{step.title}</h3><button type="button" className="ckr-flow-close" aria-label={`${step.title} açıklamasını kapat`} onClick={close}>Kapat</button></div>
              <p className="ckr-flow-subtitle">{step.subtitle}</p>
              {step.paragraphs.map((paragraph,index)=><p key={index} className="ckr-flow-paragraph">{index===step.paragraphs.length-1?<strong>{paragraph}</strong>:paragraph}</p>)}
              {step.no==='01'&&<a href="/ihtiyac-analizi/" className="ckr-btn ckr-btn-gold ckr-flow-analysis" onClick={goToAnalysis}>MOTİVASYONUMU ANALİZ ET</a>}
            </div></div>
          </section>)}
        </div>
      </div>
    </section>
  );
}
